import { VendorUomsType } from 'features/Enterprise/Vendor/types/VendorManagement'

const stripLegacyMoqUomPlaceholder = (value?: string | number | null) => {
  if (value === undefined || value === null || value === '' || value === 0 || value === '0') {
    return ''
  }
  return String(value).trim()
}

export const isMoqUomInApiList = (
  value: string | undefined | null,
  vendorUoms: VendorUomsType[],
): boolean => {
  const normalized = value?.trim()
  if (!normalized) return true
  return vendorUoms.some(
    (item) => String(item.id).trim().toUpperCase() === normalized.toUpperCase(),
  )
}

export const resolveMoqUomSelectValue = (
  value?: string | number | null,
  vendorUoms?: VendorUomsType[],
) => {
  const stripped = stripLegacyMoqUomPlaceholder(value)
  if (!stripped) return ''

  if (vendorUoms === undefined || vendorUoms.length === 0) {
    return stripped
  }

  const resolved = resolveAllowedMoqUom(stripped, vendorUoms)
  return resolved.ok ? resolved.value : ''
}

export const normalizeMoqUomForForm = (
  value: string | undefined | null,
  vendorUoms?: VendorUomsType[],
) => resolveMoqUomSelectValue(value, vendorUoms)

export const resolveAllowedMoqUom = (
  uom: string | undefined,
  vendorUoms: VendorUomsType[],
): { ok: true; value: string } | { ok: false; reason: string } => {
  const value = (uom || '').trim()
  if (!value) return { ok: true, value: '' }

  const match = vendorUoms.find(
    (item) => String(item.id).trim().toUpperCase() === value.toUpperCase(),
  )
  if (!match) {
    return {
      ok: false,
      reason: 'Satuan MoQ (moq_uom) tidak valid.',
    }
  }

  return { ok: true, value: match.id }
}

export const filterCsvRowsByAllowedMoqUom = <TRow extends { rowNumber: number; moq_uom?: string }>(
  rows: TRow[],
  vendorUoms: VendorUomsType[],
): { rows: TRow[]; failedRows: { rowNumber: number; reason: string }[] } => {
  const failedRows: { rowNumber: number; reason: string }[] = []
  const validRows: TRow[] = []

  rows.forEach((row) => {
    const resolved = resolveAllowedMoqUom(row.moq_uom, vendorUoms)
    if (!resolved.ok) {
      failedRows.push({ rowNumber: row.rowNumber, reason: resolved.reason })
      return
    }
    validRows.push(
      resolved.value === (row.moq_uom || '')
        ? row
        : { ...row, moq_uom: resolved.value || undefined },
    )
  })

  return { rows: validRows, failedRows }
}
